import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.scss'],
})
export class SignComponent implements OnInit {

  private _canvas:ElementRef<HTMLCanvasElement>;
  @ViewChild('canvas', {static: false}) set canvas(v) {
    if(this._canvas !== v) this._canvas = v;
    this.canvas.nativeElement.width = this.cWidth;
    this.canvas.nativeElement.height = this.cHeight;
    this.ctx = this.canvas.nativeElement.getContext("2d");
  }
  get canvas() { return this._canvas }
  ctx:CanvasRenderingContext2D;
  cWidth:number = 640;
  cHeight:number = 320;
  draw = {
    active: false,
    x: 0,
    y: 0
  }

  constructor(
    private _modal: ModalController
  ) {

  }
  
  ngOnInit() {

  }
  canvasMouseDown($event:MouseEvent | TouchEvent) {
    const pos = this.getPos($event);
    this.draw.active = true;
    this.draw.x = pos.x;
    this.draw.y = pos.y;
  }
  canvasMouseMove($event) {
    if(!this.draw.active) return;
    const pos = this.getPos($event);
    this.ctx.beginPath();
    this.ctx.lineWidth = 5;
    this.ctx.lineCap = "round";
    this.ctx.strokeStyle = "#222222";

    this.ctx.moveTo(this.draw.x, this.draw.y);
    this.ctx.lineTo(pos.x, pos.y);
    this.ctx.stroke();
    this.draw.x = pos.x;
    this.draw.y = pos.y;
  }
  canvasMouseUp() {
    this.draw.active = false;
  }

  reset() {
    this.ctx.clearRect(0, 0, this.cWidth, this.cHeight);
  }

  btnFooterClick() {
    this._modal.dismiss({
      dataUrl: this._canvas.nativeElement.toDataURL()
    });
  }
  private getPos($event:MouseEvent | TouchEvent) {
    var canvasRect = this.canvas.nativeElement.getBoundingClientRect();
    const touchX = $event instanceof MouseEvent ? $event.pageX : $event.touches[0].pageX;
    const touchY = $event instanceof MouseEvent ? $event.pageY : $event.touches[0].pageY;
    return {
      x: (touchX - canvasRect.x - window.scrollX)/canvasRect.width*this.cWidth,
      y: (touchY - canvasRect.y - window.scrollY)/canvasRect.width*this.cWidth
    }
  }
}

export interface SignResult {
  data: {
    dataUrl:string
  }
}